import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";

import Paperbase from './Paperbase';

export default function DrawingPage() {

 
     const { isAuthenticated} = useAuth0();
  
    return (
        <>
           {isAuthenticated && <Paperbase/>}
        </>
    )};